<template>
<main class="profile">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('profile.contract_title') }}</h1>

    <!-- Container -->
    <section class="container profile-top">
      <div class="profile-div">

        <!-- 契約情報 -->
        <div class="profile-category"></div>
        <div class="profile-information" v-if="subscribed">
          <div class="profile-info-body form subscription">
            <div class="form-group">
              <label class="form-label required">{{ $t('subscription.plan') }}</label>
              <div class="form-text">{{ subscription_plan }}</div>
            </div>
            <div class="form-group">
              <label class="form-label required">{{ $t('subscription.status') }}</label>
              <div class="form-text">{{ subscription_status }}</div>
            </div>
            <div class="form-group">
              <label class="form-label required"><template v-if="!cancelStatus">{{ $t('subscription.next_payment') }}</template><template v-else>{{ $t('signup.signup.label_expirationdate') }}</template></label>
              <div class="form-text">{{ subscription.period_end }}</div>
            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="form-group">
          <template v-if="!cancelStatus">
            <button class="button button-primary checkmark" @click.prevent="executeCancelSubscription">
              <span v-show="loading">{{ $t('common.button.cancelsubscription') }}></span>
              <span v-show="!loading">{{ $t('common.button.cancelsubscription') }}</span>
            </button>
          </template>
          <template v-else>
            <template v-if="subscription && subscription.gracePeriod">
            <button class="button button-primary checkmark" @click.prevent="resumeSubscription">
              <span v-show="loading">{{ $t('common.button.resume') }}></span>
              <span v-show="!loading">{{ $t('common.button.resume') }}</span>
            </button>
            </template>
            <template v-else>
              <div class="alert">Canceled</div>
            </template>
          </template>
        </div>
      </div>
    </section>
    <!-- /Container -->

</main>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {api} from "../../config";
  export default {
    data() {
      return {
        loading: false,
        cancelStatus: null,
        subscribed: false,
        subscription: {},
        subscription_plan: '',
        subscription_status: 'none'
      };
    },
    async mounted() {
      this.clearSubscription();

      const authUser = this.$store.getters.getAuthUser;

      this.subscribed = authUser.subscribed;

      if(authUser && authUser.subscribed) {
        /*
          "subscription": {
              "trial": false,
              "recurring": true,
              "cancelled": false,
              "gracePeriod": false,
              "ended": false,
              "plan_month": true,
              "period_end":
          },
        */
        // planや状態をセット
        if(authUser.subscription !== undefined) {

          this.subscription = authUser.subscription
          // plan
          if(this.subscription.plan_month) {
            this.subscription_plan = 'Monthly';
          }

          // trial中か利用中(recurring)
          if(this.subscription.trial || this.subscription.recurring) {
            this.cancelStatus = false;

            if(this.subscription.trial) {
              this.subscription_status = 'Trial';
            } else {
              this.subscription_status = 'Active';
            }
          } else {

            this.cancelStatus = true;
            if(this.subscription.ended || this.subscription.cancelled || this.subscription.gracePeriod) {
              this.subscription_status = 'Invalid';
              if(this.subscription.gracePeriod) {
                this.subscription_status = 'Withdraw';
              }
            }
          }
        } else {
          this.cancelStatus = true;
        }
      } else {
        this.cancelStatus = true;
      }
    },
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ]),
    },
    methods: {
      executeCancelSubscription() {
        const self = this;
      self.cancelStatus = false;
      self.$store.dispatch('showLoading', true);
      const url = '/subscription/cancel';
      axios.post(url)
          .then(() => {
            self.cancelStatus = true;
            self.$store.dispatch('showLoading', false);
            self.$router.push({ name: 'profile'})
          });
      },
      resumeSubscription() {
        const self = this;
        if(this.subscription && this.subscription.gracePeriod) {
          self.$store.dispatch('showLoading', true);
          const url = '/subscription/resume';
          axios.post(url)
              .then(() => {
                axios.get(api.currentUser)
                .then((resp) => {
                    self.cancelStatus = true;
                    self.$store.dispatch('setAuthUser', resp.data)
                    self.$store.dispatch('showLoading', false)
                    self.$router.push({ name: 'profile'})
                });
              });
        }
      },
      clearSubscription() {
        this.subscription = {
          trial: false,
          recurring: false,
          cancelled: false,
          gracePeriod: false,
          ended: false,
          plan_month: false,
          period_end: ''
        };
      },
      back() {
        this.$router.push({name: 'profile'})
      }
    }
  }
</script>
